<div class="main-content mb-4 mx-lg-4 mx-md-4 mx-sm-0 px-sm-4 px-3">
    <ms-page-title />

    <!-- Page Header -->
    <div class="page-title-wrapper">
        <div class="d-flex justify-content-between flex-row flex-wrap gap-3">
            <div>
                <!-- Search Input Group -->
                <div class="input-group position-relative">
                    <input id="search"
                        type="text"
                        class="form-control form-control-solid ps-13 pe-5"
                        placeholder="Search Users"
                        aria-label="Search Users"
                        [ngModel]="userSessionService.usersFilter.searchTerm"
                        (ngModelChange)="userSessionService.usersFilter.searchTerm = $event"
                        (keyup.enter)="loadUsers(false)"
                        aria-describedby="search-description">

                    @if (userSessionService.usersFilter.searchTerm) {
                        <button
                            class="btn btn-link position-absolute top-50 translate-middle-y p-0 border-0 bg-transparent mx-2 input-group-clear-button"
                            type="button"
                            (click)="clearSearch()"
                            aria-label="Clear search">
                            <fa-duotone-icon icon="xmark" class="text-secondary fs-6" secondaryOpacity="0.9" size="lg"/>
                        </button>
                    }

                    <div class="input-group-append">
                        <button class="btn btn-primary rounded-0 rounded-end"
                                type="button"
                                (click)="loadUsers(false)"
                                id="button-addon2">
                            Search
                        </button>
                    </div>
                </div>
                <!-- Search Input Group -->
                <div id="search-description" class="ps-2 mt-2 text-muted small fst-italic">
                    Search by name or email address
                </div>
            </div>

            <div class="d-flex gap-3">
                <ms-user-search-filter (filterApplied)="filterApplied()"></ms-user-search-filter>

                <ms-sort-dropdown [sortOptions]="sortOptions" [(selectedSortOption)]="orderBy" (selectedSortOptionChange)="setSortOrder($event)"></ms-sort-dropdown>

                <!-- Hidden outright when the viewer can neither add users nor change their status, rather
                     than opening onto an empty menu. -->
                @if (canCreateUsers() || canUpdateUserStatus()) {
                <div class="dropdown">
                    <button class="btn btn-primary dropdown-toggle" type="button" data-bs-toggle="dropdown"
                        aria-expanded="false">
                        <span>List Actions</span>
                    </button>
                    <ul class="dropdown-menu dropdown-menu-end">
                        @if (canCreateUsers()) {
                        <li>
                            <a class="dropdown-item" [disableWithoutPermission]="{
                                    requiredPermissions: [UserPermission.Create],
                                    userPermissionOnly: true
                                }"
                                (click)="onAddUserClicked()">
                                    <fa-duotone-icon icon="plus" secondaryOpacity="0.9" class="me-2" />Add User
                            </a>
                        </li>
                        }
                        <!-- Only between two groups: alone, either would open the menu with a stray rule. -->
                        @if (canCreateUsers() && canUpdateUserStatus()) {
                        <li><hr class="dropdown-divider"></li>
                        }
                        <!-- Hidden, not greyed out, without users.status - the same rule as the row actions. -->
                        @if (canUpdateUserStatus()) {
                        <li>
                            <a class="dropdown-item"
                                [class.disabled]="isSelectAll === false && selectionItems().length <= 0"
                                (click)="confirmBulkAction(UserBulkActions.Activate)">
                                <fa-duotone-icon icon="power-off" secondaryOpacity="0.9" class="me-2" />Activate
                            </a>
                        </li>
                        <li>
                            <a class="dropdown-item"
                                [class.disabled]="isSelectAll === false && selectionItems().length <= 0"
                                (click)="confirmBulkAction(UserBulkActions.Deactivate)">
                                <fa-duotone-icon icon="ban" secondaryOpacity="0.9" class="me-2" />Deactivate
                            </a>
                        </li>
                        }
                    </ul>
                </div>
                }
            </div>
        </div>
    </div>

    <div>
        <div class="d-flex flex-wrap">
            <div class="mb-0 text-start flex-grow-0 w-50" #jumpToElementMobile>
                Showing: {{userList().length || 0}} of {{totalCount | number}}
                <div class="badge bg-primary ms-0 ms-sm-2"> Selected: {{selectedCount() | number}} </div>
            </div>
            <div class="flex-grow-1 text-end d-block d-sm-none">
                <button id="toggleAllMobile" type="button" class="btn btn-ms-secondary text-start" (click)="toggleSelectAll()">
                    <fa-duotone-icon icon="square-check" secondaryOpacity="0.2" size="lg" [hidden]="!isSelectAll" />
                    <fa-duotone-icon icon="square" secondaryOpacity="0.2" size="lg" [hidden]="isSelectAll" />
                    {{ (isSelectAll) ? 'Deselect All' : 'Select All' }}
                </button>
            </div>         
        </div>
        
        <!-- Table Start -->
        <div class="table-responsive d-none d-sm-block">
            <table class="table table-hover fixed-header placeholder-glow" msResponsiveTable>
                <thead #jumpToElement>
                    <tr>
                        <th scope="col" msResponsiveTableColumn="checkbox" [priority]="1"><input id="toggleAllSelection" name="toggleAllSelection" type="checkbox" class="form-check-input fs-6" [checked]="isSelectAll" (change)="toggleSelectAll()" /></th>
                        <th scope="col" class="sortable" msResponsiveTableColumn="name" [priority]="1" (click)="toggleSortDirection('Name')">
                            Name
                            <fa-duotone-icon icon="sort" class="ms-1" size="lg"
                                [primaryOpacity]="(orderBy == userListSortOptions.NameASC || orderBy == userListSortOptions.EmailASC) ? '0.9' : '0.3' "
                                [secondaryOpacity]="(orderBy == userListSortOptions.NameDESC || orderBy == userListSortOptions.EmailDESC) ? '0.9' : '0.3' "
                            />
                        </th>
                        <th scope="col" class="sortable" msResponsiveTableColumn="role" [priority]="2" (click)="toggleSortDirection('Role')">
                            Role
                            <fa-duotone-icon icon="sort" class="ms-1" size="lg"
                                [primaryOpacity]="orderBy == userListSortOptions.RoleASC ? '0.9' : '0.3' "
                                [secondaryOpacity]="orderBy == userListSortOptions.RoleDESC ? '0.9' : '0.3' "
                            />
                        </th>
                        <th scope="col" class="sortable" msResponsiveTableColumn="status" [priority]="3" (click)="toggleSortDirection('Status')">
                            Status
                            <fa-duotone-icon icon="sort" class="ms-1" size="lg"
                                [primaryOpacity]="orderBy == userListSortOptions.StatusASC ? '0.9' : '0.3' "
                                [secondaryOpacity]="orderBy == userListSortOptions.StatusDESC ? '0.9' : '0.3' "
                            />
                        </th>
                        <th scope="col" class="sortable" msResponsiveTableColumn="lastLogin" [priority]="4"
                            (click)="toggleSortDirection('Last Login')">
                            Last Login
                            <fa-duotone-icon icon="sort" class="ms-1" size="lg"
                                [primaryOpacity]="orderBy == userListSortOptions.LastLoginASC ? '0.9' : '0.3' "
                                [secondaryOpacity]="orderBy == userListSortOptions.LastLoginDESC ? '0.9' : '0.3' "
                            />
                        </th>
                        <th class="fixed-header" scope="col" msResponsiveTableColumn="actions" [priority]="1">Actions</th>
                    </tr>
                </thead>
                <tbody>
                    <!-- Table Row Start -->
                    @for (user of displayUsers; let i= $index; track user.userId) {
                    <tr app-user-list-table-row class="align-middle" [className]="(i % 2 === 0)? 'even' : 'odd'">
                    
                        <td msResponsiveTableColumn="checkbox" [priority]="1"><input id="toggleAllSelection" type="checkbox" #toggleAllSelection class="form-check-input" [value]="user.userId" [checked]="selectionItems() | itemSelection: user.userId: isSelectAll" (click)="selectionClicked({id: user.userId, checked: toggleAllSelection.checked})" /></td>
                        <td msResponsiveTableColumn="name" [priority]="1">
                            <div class="d-flex align-items-center">
                                <ms-avatar [identity]="user" [avatarSize]="avatarSize" [avatarShape]="avatarShape"
                                    [avatarAdditionalAttributes]="avatarAdditionalAttributes" [isLoading]="isLoading"></ms-avatar>

                                <div class="min-w-0 ms-3">
                                    <div class="fw-bold text-truncate" [class.placeholder]="isLoading"
                                        [msTooltip]="(user?.firstName + ' ' + user?.lastName).trim()" msTooltipOnlyIfTruncated>
                                        {{user?.firstName + ' ' + user?.lastName}}
                                        @if (!isLoading) {
                                            @switch (user?.invitationStatus) {
                                                @case (UserInvitationStatuses.Accepted) {
                                                    <fa-duotone-icon icon="mailbox-open-letter" 
                                                        class="ps-2" 
                                                        size="lg" 
                                                        [secondaryOpacity]="0.3" 
                                                        [primaryOpacity]="0.8" 
                                                        [primaryColor]="InvitationStatusColors.Accepted" 
                                                        [secondaryColor]="InvitationStatusColors.Accepted" 
                                                        title="Accepted"
                                                        aria-label="Accepted"
                                                    />
                                                }
                                                @case (UserInvitationStatuses.Invited) {
                                                    <fa-duotone-icon icon="mailbox-flag-up" 
                                                        class="ps-2" 
                                                        size="lg" 
                                                        [secondaryOpacity]="0.3" 
                                                        [primaryOpacity]="0.8" 
                                                        [primaryColor]="InvitationStatusColors.Invited" 
                                                        [secondaryColor]="InvitationStatusColors.Invited"
                                                        title="Invited"
                                                        aria-label="Invited"
                                                    />
                                                }
                                                @case (UserInvitationStatuses.Expired) {
                                                    <fa-duotone-icon icon="hourglass-end" 
                                                        class="ps-2" 
                                                        size="lg" 
                                                        [secondaryOpacity]="0.3" 
                                                        [primaryOpacity]="0.8" 
                                                        [primaryColor]="InvitationStatusColors.Expired" 
                                                        [secondaryColor]="InvitationStatusColors.Expired"
                                                        title="Invitation Expired"
                                                        aria-label="Invitation Expired"
                                                    />
                                                }
                                                @default {
                                                    <!-- No icon -->
                                                }
                                            }
                                        }
                                    </div>
                                    <small class="d-none d-sm-block text-truncate placeholder"
                                        [class.placeholder]="isLoading"
                                        [msTooltip]="user.emailAddress" msTooltipOnlyIfTruncated>{{user?.emailAddress}}</small>
                                </div>
                            </div>
                        </td>
                        <td msResponsiveTableColumn="role" [priority]="2">
                            <span class="text-truncate d-inline-block mw-100"
                                [class.placeholder]="isLoading"
                                [msTooltip]="user.mostPermissiveRole ?? 'User'" msTooltipOnlyIfTruncated>
                                {{ user.mostPermissiveRole ?? 'User' }}
                            </span>
                        </td>
                        <td msResponsiveTableColumn="status" [priority]="3">
                            <ms-status-badge [status]="user.status" [(isLoading)]="isLoading"></ms-status-badge>
                        </td>
                        <td msResponsiveTableColumn="lastLogin" [priority]="4">
                            @if (user?.lastLogin) {
                                <span [class.placeholder]="isLoading">{{ (user?.lastLogin + "Z" ) | date:'MMM dd, yyyy h:mm a' }}</span>
                            } @else {
                                <span [class.placeholder]="isLoading">{{ 'Never' }}</span>
                            }
                        </td>
                        <td msResponsiveTableColumn="actions" [priority]="1">
                            <div class="dropdown">
                                <button class="btn btn-sm btn-ms-secondary dropdown-toggle" data-bs-toggle="dropdown"
                                    (click)="onActionsDropdownOpened(user)" [class.placeholder]="isLoading">
                                    Actions
                                </button>
                                <ul class="dropdown-menu dropdown-menu-end">
                                    <ng-container *ngTemplateOutlet="userRowActions; context: { $implicit: user }" />
                                </ul>
                            </div>
                        </td>
                    </tr>
                    }
                    <!-- Table Row End -->
                </tbody>
                <tfoot ms-pagination [take]="take" (loadMoreInView)="loadMoreInView()" [(skip)]="skip"
                    [hasNext]="hasNext" [itemCount]="displayUsers.length" (jumpToClicked)="jumpToTop($event)">
                </tfoot>
            </table>
        </div>
        <!-- Table End -->

        <div id="mobileTableCards" class="d-block d-sm-none">
            @for (user of displayUsers; let i= $index; track user.userId) {
                <div class="card d-flex pt-1 d-inline d-sm-none my-3">
                
                    <div class="d-flex flex-column card-body">
                
                        <div class="d-flex flex-row">
                            <div class="card-left-column d-block-flex text-center">
                                <ms-avatar [identity]="user" [avatarSize]="avatarSize" [avatarShape]="avatarShape" [isSelected]="selectionItems() | itemSelection: user.userId : isSelectAll"
                                    [avatarAdditionalAttributes]="avatarAdditionalAttributes" [isLoading]="isLoading" (clicked)="selectionClicked($event)"></ms-avatar>
                            </div>
                
                            <div class="right-card-column w-100">
                                <h5 class="card-title mb-0" [class.placeholder]="isLoading">{{user.firstName + ' ' +
                                    user.lastName}}</h5>
                                <div class="fw-semibold" [class.placeholder]="isLoading">{{user.emailAddress}}
                                </div>
                                <div class="card-text" [class.placeholder]="isLoading">Role: {{ user.mostPermissiveRole ?? 'User' }}
                                </div>
                                <div class="card-text" [class.placeholder]="isLoading">Last Login:
                                    @if (user?.lastLogin) {
                                        {{(user?.lastLogin + "Z" ) | date:'shortDate' }}
                                    } @else {
                                        Never
                                    }
                                </div>
                            </div>
                        </div>

                        <div class="d-flex flex-row gap-2 mt-3">
                            <ms-status-badge [status]="user.status" [(isLoading)]="isLoading"></ms-status-badge>
                            <ms-status-badge [status]="user.invitationStatus" [(isLoading)]="isLoading"></ms-status-badge>
                        </div>
                    </div>

                    <button class="mobile-action-button dropdown-toggle" data-bs-toggle="dropdown"
                        (click)="onActionsDropdownOpened(user)" [class.placeholder]="isLoading">
                        Actions
                    </button>
                    <ul class="dropdown-menu dropdown-menu-end w-75">
                        <ng-container *ngTemplateOutlet="userRowActions; context: { $implicit: user }" />
                    </ul>
                </div>
            }
            <div ms-in-view-port (inViewPort)="loadMoreInView()" ms-pagination [take]="take" [(skip)]="skip"
                [hasNext]="hasNext" [itemCount]="displayUsers.length" (jumpToClicked)="jumpToTop($event)">
            </div>

        </div>

        <ms-confirmation-modal #userListConfirmationModalRef modalId="userListConfirmationModal"
            [enableNotes]="true" [isNoteRequired]="false"
            [(isSubmitting)]="isSubmitting"
            confirmButtonText="Yes" cancelButtonText="No"
            (confirmed)="confirmationConfirmFunction($event)" 
            (cancelled)="confirmationCancelFunction()" 
        />

        <ms-info-modal #userListInfoModalRef modalId="userListInfoModal" />

        <ms-add-user />
    </div>
</div>

<!-- Row actions for the users desktop table and mobile cards. Each status action is hidden rather
     than greyed out when the viewer can't take it — on their own record, or on an account whose
     authority they can't outrank (a Staff or System Administrator target) — see the canShow*
     methods on the component. The authority check runs when the dropdown opens, so a neutral
     placeholder stands in until it resolves rather than a label that would then disappear. -->
<ng-template #userRowActions let-user>
    <li>
        <a class="dropdown-item" [routerLink]="['/users/profile/', user.userId]"
            [disableWithoutPermission]="{
                requiredPermissions: [UserPermission.Read],
                userPermissionOnly: true
            }">
            <fa-duotone-icon icon="eye" secondaryOpacity="0.9" class="me-2" />View
        </a>
    </li>

    @if (isResolvingRowActions(user)) {
        <li>
            <a class="dropdown-item disabled" aria-disabled="true" tabindex="-1">
                <div class="spinner-border spinner-border-sm me-2" role="status"><span class="visually-hidden">Loading...</span></div>Checking access...
            </a>
        </li>
    } @else {
        @if (canShowReactivate(user)) {
            <li>
                <a class="dropdown-item" (click)="confirmUserActivationStatusUpdate(UserStatuses.Active, user)">
                    <fa-duotone-icon icon="power-off" secondaryOpacity="0.9" class="me-2" />Reactivate
                </a>
            </li>
        }
        @else if (canShowDeactivate(user)) {
            <li>
                <a class="dropdown-item" (click)="confirmUserActivationStatusUpdate(UserStatuses.Inactive, user)">
                    <fa-duotone-icon icon="ban" secondaryOpacity="0.9" class="me-2" />Deactivate
                </a>
            </li>
        }
        @if (canShowDelete(user)) {
            <li>
                <a class="dropdown-item" (click)="confirmUserDeletion(user)">
                    <fa-duotone-icon icon="trash" secondaryOpacity="0.9" class="me-2" />Delete
                </a>
            </li>
        }
    }
</ng-template>
